// Copyright Epic Games, Inc. All Rights Reserved.

export class StatusCodeError extends Error {
  statusCode: number;

  constructor(statusCode: number, message: string) {
    super(message);

    // Jest does not work with it. :
    this.statusCode = statusCode;
  }
}
